"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPayment = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const Button_1 = require("../../../Button");
const SelectPayment = (props) => {
    var _a, _b, _c, _d;
    const { select, paymentTermsConfig, disabled } = props;
    const buttons = [
        {
            render: () => {
                var _a;
                return (react_1.default.createElement(Button_1.Button, { key: 'now', icon: 'coins', text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:payNow', defaultMessage: 'Pay now' })), onClick: () => select('now'), disabled: ((_a = paymentTermsConfig.now) === null || _a === void 0 ? void 0 : _a.disabled) || disabled }));
            },
            hidden: (_a = paymentTermsConfig.now) === null || _a === void 0 ? void 0 : _a.hidden,
        },
        {
            render: () => {
                var _a;
                return (react_1.default.createElement(Button_1.Button, { key: 'later', icon: 'history', text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:payLatter', defaultMessage: 'Pay later' })), onClick: () => select('later'), disabled: ((_a = paymentTermsConfig.later) === null || _a === void 0 ? void 0 : _a.disabled) || disabled }));
            },
            hidden: (_b = paymentTermsConfig.later) === null || _b === void 0 ? void 0 : _b.hidden,
        },
        {
            render: () => {
                var _a;
                return (react_1.default.createElement(Button_1.Button, { key: 'airport', icon: 'airport', text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:payAirport', defaultMessage: 'Pay in Airport' })), onClick: () => select('airport'), disabled: ((_a = paymentTermsConfig.airport) === null || _a === void 0 ? void 0 : _a.disabled) || disabled }));
            },
            hidden: (_c = paymentTermsConfig.airport) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            render: () => {
                var _a;
                return (react_1.default.createElement(Button_1.Button, { key: 'bill', icon: 'invoice', text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:payInvoice', defaultMessage: 'Pay by Invoice' })), onClick: () => select('bill'), disabled: ((_a = paymentTermsConfig.bill) === null || _a === void 0 ? void 0 : _a.disabled) || disabled }));
            },
            hidden: (_d = paymentTermsConfig.bill) === null || _d === void 0 ? void 0 : _d.hidden,
        },
    ];
    const renderPayButtons = () => buttons.filter(x => !x.hidden).map(x => x.render());
    const renderUpdateButton = () => {
        var _a, _b;
        if ((_a = paymentTermsConfig.update) === null || _a === void 0 ? void 0 : _a.hidden)
            return null;
        return (react_1.default.createElement(Button_1.Button, { key: 'update', text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:update', defaultMessage: 'Update' })), onClick: () => select('update'), disabled: ((_b = paymentTermsConfig.update) === null || _b === void 0 ? void 0 : _b.disabled) || disabled }));
    };
    return (react_1.default.createElement("div", { className: `${__1.className}__buttons` }, paymentTermsConfig.mode === 'new' ? renderPayButtons() : renderUpdateButton()));
};
exports.SelectPayment = SelectPayment;
//# sourceMappingURL=SelectPayment.js.map